import { render, staticRenderFns } from "./ModalEditCourse.vue?vue&type=template&id=55a03630&scoped=true&"
import script from "./ModalEditCourse.vue?vue&type=script&lang=js&"
export * from "./ModalEditCourse.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditCourse.vue?vue&type=style&index=0&id=55a03630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a03630",
  null
  
)

export default component.exports